import { Component, ComponentInterface, Element, h, Host, Prop, Watch } from '@stencil/core';

interface UiCmsContainerBody {
  backgroundStyle: HTMLUiContainerElement['variant'];
  isFullWidth?: boolean;
  isMarkenform?: boolean;
  noPadding?: boolean;
}

@Component({
  tag: 'ui-cms-container',
  styleUrls: { default: 'ui-cms-container.scss', editing: 'ui-cms-container.magnolia.scss' },
})
export class UiCmsContainer implements ComponentInterface {
  @Element() el: HTMLElement;

  @Prop({ mutable: true }) body: UiCmsContainerBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  container: HTMLElement;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  private setVariantWhiteFor(componentName) {
    const componentsToBeWhite = [].slice.call(this.el.querySelectorAll(componentName));

    if (componentsToBeWhite.length > 0 && componentName === 'ui-cms-headline') {
      componentsToBeWhite.forEach((component) => component.setAttribute('icon-variant', 'white'));
    } else if (componentsToBeWhite.length > 0) {
      componentsToBeWhite.forEach((component) => component.setAttribute('variant', 'white'));
    }
  }

  /**
   * sets the inverted property on every child of the ui-cms-container.
   * This is important for the skinning of the sds components.
   */
  private setInvertedProps(): void {
    Array.from(this.el.children).forEach((element: HTMLElement) => {
      if (this.checkIfElemHasSdClass(element)) {
        const invertedClass = `${this.checkIfElemHasSdClass(element)}--inverted`;
        element.classList.add(invertedClass);
      } else {
        element.setAttribute('inverted', 'true');
      }
    });
  }

  private checkIfElemHasSdClass(element: HTMLElement): string {
    const classes = element.className.split(/\s+/);
    const sdClass = classes.find((cls) => cls.startsWith('sd-'));
    return sdClass;
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);

    // TODO: PB2B-8436 check if we can move inverted logic to magnolia
    if (this.body.backgroundStyle === 'primary') {
      this.setInvertedProps();
    }
  }

  componentDidLoad() {
    [].slice.call(this.el.children).forEach((child) => {
      child.update?.();
    });

    // TODO: PB2B-8436 check if this is still needed and if we can move inverted logic to magnolia
    if (this.body.backgroundStyle === 'primary') {
      this.setVariantWhiteFor('ui-cms-headline');
      this.setVariantWhiteFor('ui-cms-footnote-list');
      this.setVariantWhiteFor('ui-cms-list');
      this.setVariantWhiteFor('ui-cms-teaser-group');
      this.setVariantWhiteFor('ui-cms-teaser-group-tile');
      this.setVariantWhiteFor('ui-cms-link-list');
      this.setVariantWhiteFor('ui-cms-newsletter-cta');
      this.setVariantWhiteFor('ui-cms-table');
      this.setVariantWhiteFor('ui-cms-quickfact');
    }
  }

  render() {
    return (
      <Host class={this.body.backgroundStyle}>
        <ui-container
          variant={this.body.backgroundStyle}
          fullWidth={this.body.isFullWidth}
          stylized={this.body.isMarkenform}
          noPadding={this.body.noPadding}
          ref={(el) => {
            this.container = el;
          }}
        >
          <slot />
        </ui-container>
      </Host>
    );
  }
}
